import { BrowserRouter } from 'react-router-dom';
import { CompatRouter } from 'react-router-dom-v5-compat';

import { FeatureFlagsProvider } from '@project44/feature-flags';
import { ReactHooksApplication } from '@project44/iam-team-ui-utils';
import { RequireTranslations } from '@project44/translations-utils';
import { getP44Env, User, useUser } from '@project44/ui-utils';

import { translations } from '../l10n/config';
import { SideBar, Skeleton } from './movement';
import { PACKAGE_NAME } from './utils/constants/PACKAGE_NAME';

const NON_MOVEMENT_REFERRER_KEY = 'nonMovementReferrer';

export function App() {
  const { tenantHookController } = ReactHooksApplication.getInstance();
  const { data } = useUser();

  const [TenantSwitcherComponent, toggleTenantSwitcherComponent] =
    tenantHookController.composeUseToggleTenantSwitcherComponent({
      user: data,
    })();

  return (
    <BrowserRouter>
      <CompatRouter>
        <SideBar
          toggleTenantSwitcherComponent={toggleTenantSwitcherComponent}
        />
        <TenantSwitcherComponent />
      </CompatRouter>
    </BrowserRouter>
  );
}

const isMovementUrl = (url: string): boolean => {
  const { MOVEMENT_BASE_URL } = getP44Env();

  url = url.toLowerCase().replace(/^(https?:\/\/|)/i, '');
  const movementBaseUrl = MOVEMENT_BASE_URL.toLowerCase().replace(
    /^(https?:\/\/|)/i,
    '',
  );
  return url.startsWith(movementBaseUrl);
};

function comesFromNonMovementReferrer(loggedInUser?: User) {
  //check for the URL parameter and the tenant property
  const nonMovementReferrerParam = new URLSearchParams(
    window.location.search,
  ).get(NON_MOVEMENT_REFERRER_KEY);

  const afterLoginRedirect: string =
    loggedInUser?.customerProperties.DEFAULT_LANDING_URL_AFTER_LOGIN || '';

  const isNonMovementReferrer =
    nonMovementReferrerParam?.toLowerCase() === 'true';

  if (
    isNonMovementReferrer &&
    !isMovementUrl(afterLoginRedirect) &&
    !!loggedInUser?.customerProperties
  ) {
    sessionStorage.setItem(NON_MOVEMENT_REFERRER_KEY, JSON.stringify(true));
    return true;
  }
  sessionStorage.removeItem(NON_MOVEMENT_REFERRER_KEY);
  return false;
}

const shouldHideSideBar = (loggedInUser?: User) => {
  const isNonMovementSession =
    sessionStorage.getItem(NON_MOVEMENT_REFERRER_KEY) !== null;

  if (isNonMovementSession) {
    return true;
  }

  return comesFromNonMovementReferrer(loggedInUser);
};

export default function AppProvider() {
  const { data } = useUser();

  return shouldHideSideBar(data) ? (
    <></>
  ) : (
    <RequireTranslations namespace={PACKAGE_NAME} translations={translations}>
      <FeatureFlagsProvider loadingComponent={<Skeleton />}>
        <App />
      </FeatureFlagsProvider>
    </RequireTranslations>
  );
}
